import React, { useEffect, useState } from 'react';
import './invited-users.scss';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { Button, Col, FormFeedback, Label } from 'reactstrap';
import { Controller, UseFormReturn } from 'react-hook-form';
import {
  useCompanyManagementUsers,
  useFetchMyCompanyUsers,
} from '../../../../store/CompanyManagement/companyManagementHooks';

type PropsTypes = {
  showBookInfo: () => void;
  form: UseFormReturn<any, object>;
};

const InvitedUsers = ({ showBookInfo, form }: PropsTypes) => {
  const fetchUsers = useFetchMyCompanyUsers();
  const users = useCompanyManagementUsers();
  const [options, setOptions] = useState<{ label: string; value: number }[]>(
    []
  );

  useEffect(() => {
    if (!users?.length) {
      fetchUsers().finally();
    }
  }, []);

  useEffect(() => {
    const newOptions = users.map((user) => ({
      label: user.fullName,
      value: user.id,
    }));
    setOptions(newOptions);
  }, [users.length]);

  const {
    formState: { errors },
  } = form;
  const { t } = useTranslation();

  return (
    <div className="book-room-invited-users">
      <Col md="12" className="form-user-input">
        <div className="invited-users-title">{t('INVITED_USERS_TITLE')}</div>
        <div>
          <Label for="available_days">{t('INVITED_USERS_TITLE')}</Label>
          <Controller
            name="invited_users"
            control={form.control}
            render={({ field: { onChange, value } }) => (
              <Select
                isClearable={false}
                isMulti
                value={options.filter((c: any) => value?.includes(c.value))}
                onChange={(value) => onChange(value.map((item) => item.value))}
                options={options}
                className="react-select"
                classNamePrefix="select"
              />
            )}
          />
          {errors.availableDays ? (
            <FormFeedback className="form-input-error">
              {t('FORM_ERRORS_FIELD_IS_REQUIRED')}
            </FormFeedback>
          ) : null}
        </div>
      </Col>
      <Button
        className="show-book-info-button"
        type="button"
        color=""
        onClick={showBookInfo}
      >
        {t('BACK_BUTTON_TEXT')}
      </Button>{' '}
    </div>
  );
};

export default InvitedUsers;
